/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Dashboard', function ($scope,loginService,$log) {
    $scope.data = {};
    
    $scope.init = function(){
        var promise = loginService.get();
        promise.then(    
              function(payload) {                                               
                  $scope.data = payload.data;
              },    
              function(errorPayload) {    
                  $log.error('Błąd ładowania użytkownika', errorPayload);    
              }); 
    };
    
    $scope.init();    
});                 